import { BUTTON_ICON_SIZES, BUTTON_PADDING_SIZES, BUTTON_TEXT_PROPS } from '../Button/Button.constants';
// Constants.
// -----------------------------------------------------------------------------
export const BUTTON_LINK_DEFAULT_DISABLED = false;
export const BUTTON_LINK_DEFAULT_IS_LOADING = false;
export const BUTTON_LINK_DEFAULT_MODE = 'light';
export const BUTTON_LINK_DEFAULT_SCHEMA = 'brand2';
export const BUTTON_LINK_DEFAULT_SIZE = 's';
export const BUTTON_LINK_DEFAULT_VARIANT = 'bare';
export const BUTTON_LINK_TEXT_PROPS = BUTTON_TEXT_PROPS;
export const BUTTON_LINK_PADDING_SIZES = BUTTON_PADDING_SIZES;
export const BUTTON_LINK_ICON_SIZES = BUTTON_ICON_SIZES;
//# sourceMappingURL=ButtonLink.constants.js.map